export const PERSONA_LIMIT = {
  FREE: 3,
  PAID_MINIMAL: 10,
  PAID_BASIC: 50,
  PAID_PREMIUM: 100,
};

export const EDIT_PERSONA_PAGE_URL = "/personas/edit";

// Constants for field limitations
export const PERSONA_FIELD_LIMITS = {
  NAME: 20,
  HIGHLIGHT: 1000,
};

export const PERSONA_FIELD_MIN_LENGTH = 3;

export const PERSONA_EDIT_NOT_FOUND_STATUS_CODE = 404;
